import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { md, lg, xl, wide, xwide } from '../common';

export function initBlockClients(parent) {
  if (!parent) return;

  const nextEl = parent.querySelector('.swiper-button-next');
  const prevEl = parent.querySelector('.swiper-button-prev');
  const swiperEl = parent.querySelector('.block-clients__swiper');
  const paginationEl = swiperEl.querySelector('.swiper-pagination');

  new Swiper(swiperEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 20,
    navigation: {
      prevEl: prevEl,
      nextEl: nextEl,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    breakpoints: {
      [md]: { slidesPerView: 2, spaceBetween: 20 },
      [lg]: { slidesPerView: 3, spaceBetween: 20 },
      [wide]: { slidesPerView: 3, spaceBetween: 24 },
      [xwide]: { slidesPerView: 3, spaceBetween: 32 },
    },
  });
}

export function initAllBlockClients() {
  const blocks = document.querySelectorAll('.js-block-clients');
  blocks.forEach((block) => initBlockClients(block));
}
